import { Check, Clipboard } from "lucide-react";
import { useState } from "react";

export function CopyButton({
  value,
  label = "Copy",
}: {
  value: unknown;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const text =
      typeof value === "string" ? value : JSON.stringify(value, null, 2);
    if (!text || !navigator.clipboard) return;
    await navigator.clipboard.writeText(text);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1_500);
  };
  return (
    <button
      type="button"
      className="inline-flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-semibold text-stone-400 transition hover:bg-stone-100 hover:text-stone-700 dark:hover:bg-white/10 dark:hover:text-stone-200"
      onClick={() => void copy()}
      title={label}
    >
      {copied ? <Check size={12} /> : <Clipboard size={12} />}
      {copied ? "Copied" : label}
    </button>
  );
}
